import UpdatePurchaseOrder from "../../../../components/@documents/purchase_orders/UpdatePurchaseOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseOrderUpdatePage() {

    return (
        <UpdatePurchaseOrder 
            routeType={routeTypes.retail}
        />
    )
}